import wpOcService from './wp-oc-service'

const mailService = {}

mailService.appointment = function (params) {
    console.log(params)
    return wpOcService.post('email/v1/appointment', params)
        .then(res =>  res.data)
}

export default mailService


// WEBPACK FOOTER //
// ./src/ws/email.js